import api from './api';

export interface UploadImagemResponse {
  caminhoImagem: string;
  nomeArquivo: string;
  nomeOriginal: string;
  tamanho: number;
  tipoMime: string;
}

export class ImagemService {
  private baseUrl = '/imagem';

  async uploadImagem(arquivo: File): Promise<UploadImagemResponse> {
    const formData = new FormData();
    formData.append('imagem', arquivo);

    const response = await api.post<UploadImagemResponse>(
      `${this.baseUrl}/upload`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return response.data;
  }

  async buscarImagem(nomeArquivo: string): Promise<Blob> {
    const nome = nomeArquivo.split('/').pop() || nomeArquivo;
    const response = await api.get(`${this.baseUrl}/${nome}`, {
      responseType: 'blob',
    });

    return response.data;
  }

  async deletarImagem(nomeArquivo: string): Promise<void> {
    const nome = nomeArquivo.split('/').pop() || nomeArquivo;
    await api.delete(`${this.baseUrl}/${nome}`);
  }

  /**
   * HF-5: preview autenticado via blob (GET /imagem exige JWT; não usar URL estática pública).
   */
  async criarPreviewObjectUrl(caminhoImagem: string): Promise<string> {
    if (!caminhoImagem) return '';
    const blob = await this.buscarImagem(caminhoImagem);
    return URL.createObjectURL(blob);
  }
}

export const imagemService = new ImagemService();
